export const REMOVED_LOCATION_LABEL = 'Removed location — please update';
